export enum OrganizationType {
  NYCBS = "HhwIHO4npKhrxyylkC33",
  MBM = "3GKbZtgpPru1vJGCkxwR",
  MBP = "3GKbZtgpPru1vJGCkxwR",
  CHC = "4BlQ4SsqAVTDgFKApKZr",
  ASTERA = "tPvNbDprUnrXIJlDXyxs",
  DEMO_FACILITY = "57zhkss5CaF9dz90wcpv",
  NYCBS_DRUG_CONFIG = "hwKXreFwPrMpA8Pad7Mr",
  NYCBS_PHARMA = "hwKXreFwPrMpA8Pad7Mr",
  UCBC = "W14MolgUu7OYvX4CFQJn",
  NYCBS_HYD = "Y15ePfa5kC35QiChxXil",
  ASTERA_PRIMARY_CARE = "Q0n3aZ2ZohYkn1SIrZsJ",
  NYCBS_STATS_DEV = "1y43wtT4sV1UMfZfSQUr",
  NYCBS_STATS = "olNdYB5vkpQ9beIlZ052",
}
